import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MultiSelectModule } from 'primeng/multiselect';
import { ArticleCardLoadingComponent } from '../shared/components/article-card-loading/article-card-loading.component';
import { ArticleCardComponent } from '../shared/components/article-card/article-card.component';
import { LazyLoadDirective } from '../shared/directives/lazy-load.directive';
import { ArticlesComponent } from './articles.component';
import { mergeMap, Observable } from 'rxjs';
import { Article, ArticleCategory } from '../admin/shared/public-api';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    ArticleCardComponent,
    ArticleCardLoadingComponent,
    LazyLoadDirective,
  ],
})
export class RoadTripArticlesComponent extends ArticlesComponent {
  country: string;

  constructor(
    private route: ActivatedRoute,
    titleService: Title,
  ) {
    super(route, titleService);
    this.country = this.route.snapshot.params['country'] ?? '';
    this.title = `Roadtrips ${this.country ? '- ' + this.country : ''} - Les Explorateurs du monde`;

    this.h1 = `Roadtrips ${this.country ? '- ' + this.country : ''}`;
    if (this.country) {
      this.description = `Voici nos les roadtrips que nous avons fait en ${this.country}. Tu peux t'en inspirer pour préparer tes prochains voyages, ou simplement découvrir de nouvelles pépites !`;
    } else {
      this.description = `Voici nos les roadtrips que nous avons fait. Tu peux t'en inspirer pour préparer tes prochains voyages, ou simplement découvrir de nouvelles pépites !`;
    }
    const baseUrl = environment.baseUrl;
    // Get the current path from the activated route
    const currentPath = '/' + route.snapshot.url.map((segment) => segment.path).join('/');
    let url = `${baseUrl}${currentPath}`;

    titleService.setTitle(this.title);
    this.metaTagService.updateMetaTags(
      this.description,
      this.title,
      url,
      'website',
      `${baseUrl}og_img.png`,
      768,
      432,
      'image/png',
    );
  }

  override getArticlesObservable(): Observable<Article[]> {
    if (this.country) {
      return this.destinationService
        .getDestinationByCountry(this.country)
        .pipe(
          mergeMap((d) =>
            this.articleService.getArticlesWithFilter(
              ArticleCategory.RoadTrip,
              d.id,
              this.articles.length,
              this.TAKE,
            ),
          ),
        );
    } else {
      return this.articleService.getArticlesWithFilter(
        ArticleCategory.RoadTrip,
        null,
        this.articles.length,
        this.TAKE,
      );
    }
  }
}
